import React from 'react';
import { Link } from '@material-ui/core';
import { Col, Container, Row } from 'react-bootstrap';

const Footer = () => {

	//REACT_APP_VERSION=$npm_package_version
	//REACT_APP_NAME=$npm_package_name
	
	const hardcodedVersion = "2.4.2"
	const currentYear = new Date().getFullYear()
	const currentAppVersion = `Version: ${hardcodedVersion}` //`Version: ${process.env.REACT_APP_VERSION || hardcodedVersion}`

	return (

		<div className="main-footer text-center" style={{position: 'fixed',
			width: '100%'}}>
			<Container>
				<Row className="row-sm">
					<Col md={12} className="col-md-12">
						<span>Copyright © {currentYear} <Link href="#">Smarpay</Link>. Created by <Link href="https://www.smarpay.eu/">Smarpay AG</Link>. All rights reserved. {currentAppVersion}</span>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
